/**
 * @file コンポーネント：フル動画ページダイジェスト動画 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPlayer = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
`;
